import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { getRequiredLabItemNames } from '@core/src/nedoShared/features/consultations/helpers/requiredAttachments';
import { ChatMessageClient } from '../../ChatMessageClient';
export const AttachmentRequirementVerificationMessage = ({ consultation, attachment, onActionClick, }) => {
    const { t } = useTranslation();
    const itemNames = getRequiredLabItemNames(consultation);
    const requiredTests = itemNames.map((test) => `• ${test}`).join('\n');
    const reasonText = attachment.reason
        ? `${t('label.result_rejected_reason')} "${attachment.reason}" \n`
        : '';
    const content = `${t('label.result_rejected')} \n
    ${reasonText}${t('label.following_results_required')} \n ${requiredTests}`;
    const message = {
        _id: 'test',
        version: 0,
        created: new Date().toISOString(),
        role_id: 0,
        modified: null,
        chat_id: consultation.chat_id,
        thread_id: null,
        content: content,
        attachments: [],
    };
    const actions = [
        { type: 'upload-test-result', disabled: attachment.verified },
        // { type: 'print-pdf', data: { url: '' } },
    ];
    if (attachment.verified) {
        const verifiedMessage = Object.assign(Object.assign({}, message), { content: t('label.uploaded_lab_results_verified'), attachments: [] });
        return (_jsx(ChatMessageClient, { role: 'provider', message: verifiedMessage, actions: [], onActionClick: onActionClick, showTimestamp: false }));
    }
    return (_jsx(ChatMessageClient, { role: 'provider', message: message, actions: actions, onActionClick: onActionClick, showTimestamp: false }));
};
